export default "__VITE_ASSET__DNPRvyCS__"